import {
  useInitData,
  useIsDashboardAvailable,
  useUserData,
} from '../../../hooks'
import { CustomLink } from '../../CustomLink'

import { getCompanyHomePageLink } from './CompanyLink.utils'

import * as styles from './CompanyLink.module.css'

function CompanyLink({ children, className = styles.CompanyLink }) {
  const { availableSections } = useInitData()
  const isDashboardAvailable = useIsDashboardAvailable()
  const userData = useUserData()

  const toLink = getCompanyHomePageLink({
    availableSections,
    isDashboardAvailable,
    userData,
  })

  return (
    <CustomLink className={className} to={toLink}>
      {children}
    </CustomLink>
  )
}

export default CompanyLink
